import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allIcons } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import { setSelectedChat } from "../../../lib/slices/selectedChatSlice";

const SelectedClient = ({ data, setOpen }) => {
  const navigate = useNavigate();
  const { user, services, event } = data;

  const dispatch = useDispatch();
  const selectedUser = useSelector(
    (state) => state.selectedClient.selectedClient
  );

  return (
    <Stack p={4} alignItems={"center"} gap={1.5} textAlign={"center"} mt={3}>
      {/* <Typography variant="h1" fontSize={"1.25rem"} fontWeight={500}>
        Client Details
      </Typography> */}
      <Avatar
        src={user?.image}
        sx={{ height: 100, width: 100, margin: "20px 0px" }}
      />
      <Box>
        <Typography variant="h3" fontSize={"0.85rem"} fontWeight={500}>
          {user?.username}
        </Typography>
        <Typography
          variant="h1"
          fontSize={"0.95rem"}
          fontWeight={500}
          margin={"2px 0"}
          color={"#000"}
        >
          {user?.email}
        </Typography>
        <Typography variant="h1" fontSize={"0.85rem"} fontWeight={500}>
          {user?.contact}
        </Typography>
        <Stack direction={"row"} alignItems={"center"} mt={2}>
          <GlobalButton
            handleClickBtn={() => {
              setOpen(false);
              navigate("/dashboard/booking");
              localStorage.setItem("selectedUser", JSON.stringify(data));
              dispatch(setSelectedChat(data));
            }}
            btnText={"chat with me"}
            startIcon={
              <img src={allIcons.chatWhiteIcon} alt={"chat-icon"} width={15} />
            }
            styleProps={{
              marginTop: "10px",
              marginRight: "10px",
              height: 40,
              width: 250,
              fontWeight: 400,
              fontSize: 12,
              textTransform: "lowercase",
            }}
          />
          {/* {  <GlobalButton
            btnText={"View Profile"}
            // startIcon={
            //   <img
            //     src={user?.image}
            //     alt={"chat-icon"}
            //     width={15}
            //     style={{ borderRadius: 100 }}
            //   />
            // }
            variant={"outlined"}
            styleProps={{
              width: 120,
              marginTop: "10px",
              height: 40,
              marginLeft: "10px",
              fontWeight: 400,
              bgcolor: "#FFF",
              color: "#EA580C",
              fontSize: 12,
              textTransform: "lowercase",
            }}
          />} */}
        </Stack>
        {/* <Typography variant="body2" fontSize={"0.875rem"}>
          {selectedUser?.location}
        </Typography> */}
        {/* <List sx={{ mt: 1 }}>
          <ListItem sx={{ py: "2px", cursor: "pointer" }}>
            <ListItemIcon sx={{ minWidth: 30 }}>
              <img src={allIcons.phoneOutgoingIcon} alt="00000000" width={20} />
            </ListItemIcon>
            <ListItemText
              primary={user?.contact}
              sx={{
                "& .MuiListItemText-primary ": {
                  fontSize: "0.875rem",
                },
              }}
            />
          </ListItem>
          <ListItem sx={{ py: "2px", cursor: "pointer" }}>
            <ListItemIcon sx={{ minWidth: 30 }}>
              <img src={allIcons.googleLogoIcon} alt="00000000" width={20} />
            </ListItemIcon>
            <ListItemText
              primary={user?.email}
              sx={{
                "& .MuiListItemText-primary ": {
                  fontSize: "0.875rem",
                },
              }}
            />
          </ListItem>
          <ListItem sx={{ py: "2px", cursor: "pointer" }}>
            <ListItemIcon sx={{ minWidth: 30 }}>
              <img src={allIcons.smileyInactive} alt="00000000" width={20} />
            </ListItemIcon>
            <ListItemText
              primary={"view profile"}
              sx={{
                "& .MuiListItemText-primary ": {
                  fontSize: "0.875rem",
                },
              }}
            />
          </ListItem>

          <ListItem sx={{ py: "2px", cursor: "pointer" }}>
            <GlobalButton
              btnText={"chat with me"}
              startIcon={
                <img
                  src={allIcons.chatWhiteIcon}
                  alt={"chat-icon"}
                  width={20}
                />
              }
              styleProps={{
                marginTop: "10px",
                height: 40,
                fontWeight: 400,
                textTransform: "lowercase",
              }}
            />
          </ListItem>
        </List> */}
      </Box>
    </Stack>
  );
};

export default SelectedClient;
